import { render, staticRenderFns } from "./Kundenanalyse.vue?vue&type=template&id=60a16798&"
import script from "./Kundenanalyse.vue?vue&type=script&lang=ts&"
export * from "./Kundenanalyse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports